<script>
    import Service from "../utils/Service";

    export let config;
    export let mid;

    const service = new Service(config.model_root);

    $: childItems = loadChildItems(mid);

    function loadChildItems(id) {
        return fetch(config.model_root + 'shared/menu/load_child_items.php?mid=' + id, {
            method: "GET"
        })
            .then(response => response.json());
    }
</script>

{#await childItems}
{:then subitems}
    {#if subitems.length > 0}
        <div class="mb-4 pb-0 text-center border-top pt-4">
            <h3 class="mb-0 site-header">Zugehörige Inhalte</h3>
        </div>
        <div class="container mt-4 mb-2">
            <div class="row justify-content-center">
                {#each subitems as subitem}
                    <div class="col-12 col-sm-6 col-lg-3 mb-4">
                        <a href="/site/{subitem.urlname}-m-{subitem.mid}">
                            <div class="card info-card h-100">
                                {#if subitem.mheader_image !== "INHERIT_FROM_PARENT"}
                                    {#await service.loadFile(subitem.mheader_image)}
                                        <div class="image-placeholder">Lade...</div>
                                    {:then data}
                                        <img src="{config.application_root}files/{data.fpath}" class="card-img-top"
                                             alt="Bild">
                                    {:catch error}
                                        <div class="image-placeholder">Fehler beim Laden des Bildes</div>
                                    {/await}
                                {:else}
                                    <div class="image-placeholder">Kein Bild verfügbar</div>
                                {/if}
                                <div class="card-body">
                                    <h3 class="card-title text-center">{@html subitem.mname}</h3>
                                </div>
                            </div>
                        </a>
                    </div>
                {/each}
            </div>
        </div>
    {/if}
{/await}

<style>
    .info-card {
        border: none;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        transition: transform 0.2s;
        background-color: #586a58;
        color: white;
        overflow: hidden;
    }

    .info-card:hover {
        transform: scale(1.02);
    }

    .card-img-top {
        width: 100%;
        height: auto;
        object-fit: cover;
    }

    .card-body {
        padding: 5px 5px 15px;
    }

    .card-title {
        font-size: 1.2rem;
        font-weight: bold;
        margin: 10px 0 0 0;
    }

    .image-placeholder {
        width: 100%;
        height: 94px;
        background-color: #ddd;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        font-size: 14px;
    }

    .site-header {
        font-size: 1.6em;
    }

    @media (min-width: 576px) {
        .site-header {
            font-size: 1.8em;
        }
    }

    a:hover {
        text-decoration: none;
    }
</style>
